const isComponentOutOfScreen = (boundingClientRect, component) => {
	return boundingClientRect.right + component.offsetWidth > window.innerWidth
}

export {
	isComponentOutOfScreen
}
